"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Select = _interopRequireDefault(require("../form-elements/Select"));
var _Input = _interopRequireDefault(require("../form-elements/Input"));
var _DatePicker = _interopRequireDefault(require("../form-elements/datepickers/DatePicker"));
var _TextArea = _interopRequireDefault(require("../form-elements/TextArea"));
var _ActionButton = _interopRequireDefault(require("./../buttons/ActionButton"));
var _events = require("../../utils/events");
var _helpers = require("../../utils/helpers");
var _FormModule = _interopRequireDefault(require("./../../scss/form-elements/Form.module.scss"));
const formSettings = {
  categories: [{
    value: 5,
    label: 'Closed Captioning',
    subcategories: [{
      value: 16,
      label: 'Closed Captioning Issue'
    }]
  }, {
    value: 1,
    label: 'Programming',
    subcategories: [{
      value: 1,
      label: 'Question or Comment About the Schedule'
    }, {
      value: 2,
      label: 'Question or Comment About Specific Show or Episode'
    }, {
      value: 3,
      label: 'Other'
    }]
  }, {
    value: 2,
    label: 'Technical Difficulties',
    subcategories: [{
      value: 4,
      label: 'Closed Captioning Issue'
    }, {
      value: 5,
      label: 'Loss of Signal'
    }, {
      value: 6,
      label: 'Audio Issues'
    }, {
      value: 7,
      label: 'Other'
    }]
  }, {
    value: 3,
    label: 'Commercials/Marketing',
    subcategories: [{
      value: 8,
      label: 'Question or Comment About an Infomercial or Advertisement/Commercial'
    }, {
      value: 9,
      label: 'Question or Comment About a Network or Show Promo'
    }, {
      value: 10,
      label: 'Question or Comment About Graphics or Branding'
    }, {
      value: 11,
      label: 'Other'
    }]
  }, {
    value: 4,
    label: 'Website',
    subcategories: [{
      value: 12,
      label: 'Technical Difficulties'
    }, {
      value: 13,
      label: 'Streaming Request'
    }, {
      value: 14,
      label: 'Sweepstakes or Contest Question'
    }, {
      value: 15,
      label: 'Other'
    }]
  }],
  providers: [{
    value: 1,
    label: 'Over the Air/Antenna'
  }, {
    value: 8,
    label: 'Altice (Cablevision / Suddenlink)'
  }, {
    value: 4,
    label: 'AT&T'
  }, {
    value: 2,
    label: 'Charter Spectrum (Time Warner / Bright House)'
  }, {
    value: 3,
    label: 'Comcast / Xfinity'
  }, {
    value: 7,
    label: 'Cox'
  }, {
    value: 9,
    label: 'DirecTV'
  }, {
    value: 5,
    label: 'Dish Network'
  }, {
    value: 6,
    label: 'Verizon FiOS'
  }, {
    value: 10,
    label: 'Other'
  }],
  validation: {
    category: 'required',
    subcategory: 'required',
    firstname: 'required',
    lastname: 'required',
    email: 'required|email',
    phoneNumber: 'phone-number',
    state: 'required',
    city: 'required',
    zipcode: 'required|zip-code:5',
    issueStartDate: 'date_format:YYYY-MM-DD',
    issueEndDate: 'date_format:YYYY-MM-DD',
    provider: 'required'
  }
};
const usStates = [{
  value: "AL",
  label: "AL"
}, {
  value: "AK",
  label: "AK"
}, {
  value: "AS",
  label: "AS"
}, {
  value: "AZ",
  label: "AZ"
}, {
  value: "AR",
  label: "AR"
}, {
  value: "CA",
  label: "CA"
}, {
  value: "CO",
  label: "CO"
}, {
  value: "CT",
  label: "CT"
}, {
  value: "DE",
  label: "DE"
}, {
  value: "DC",
  label: "DC"
}, {
  value: "FM",
  label: "FM"
}, {
  value: "FL",
  label: "FL"
}, {
  value: "GA",
  label: "GA"
}, {
  value: "GU",
  label: "GU"
}, {
  value: "HI",
  label: "HI"
}, {
  value: "ID",
  label: "ID"
}, {
  value: "IL",
  label: "IL"
}, {
  value: "IN",
  label: "IN"
}, {
  value: "IA",
  label: "IA"
}, {
  value: "KS",
  label: "KS"
}, {
  value: "KY",
  label: "KY"
}, {
  value: "LA",
  label: "LA"
}, {
  value: "ME",
  label: "ME"
}, {
  value: "MH",
  label: "MH"
}, {
  value: "MD",
  label: "MD"
}, {
  value: "MA",
  label: "MA"
}, {
  value: "MI",
  label: "MI"
}, {
  value: "MN",
  label: "MN"
}, {
  value: "MS",
  label: "MS"
}, {
  value: "MO",
  label: "MO"
}, {
  value: "MT",
  label: "MT"
}, {
  value: "NE",
  label: "NE"
}, {
  value: "NV",
  label: "NV"
}, {
  value: "NH",
  label: "NH"
}, {
  value: "NJ",
  label: "NJ"
}, {
  value: "NM",
  label: "NM"
}, {
  value: "NY",
  label: "NY"
}, {
  value: "NC",
  label: "NC"
}, {
  value: "ND",
  label: "ND"
}, {
  value: "MP",
  label: "MP"
}, {
  value: "OH",
  label: "OH"
}, {
  value: "OK",
  label: "OK"
}, {
  value: "OR",
  label: "OR"
}, {
  value: "PW",
  label: "PW"
}, {
  value: "PA",
  label: "PA"
}, {
  value: "PR",
  label: "PR"
}, {
  value: "RI",
  label: "RI"
}, {
  value: "SC",
  label: "SC"
}, {
  value: "SD",
  label: "SD"
}, {
  value: "TN",
  label: "TN"
}, {
  value: "TX",
  label: "TX"
}, {
  value: "UT",
  label: "UT"
}, {
  value: "VT",
  label: "VT"
}, {
  value: "VI",
  label: "VI"
}, {
  value: "VA",
  label: "VA"
}, {
  value: "WA",
  label: "WA"
}, {
  value: "WV",
  label: "WV"
}, {
  value: "WI",
  label: "WI"
}, {
  value: "WY",
  label: "WY"
}];
const categories = formSettings.categories.map(cat => {
  return {
    label: cat.label,
    value: cat.value
  };
});
function AudienceRelationsForm(_ref) {
  let {
    handleSubmit = null,
    serverErrors = []
  } = _ref;
  const [currentCategory, setCurrentCategory] = (0, _react.useState)(0);
  const [subcategories, setSubcategories] = (0, _react.useState)([]);
  const [hasValidationErrors, setHasValidationErrors] = (0, _react.useState)(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = (0, _react.useState)(false);
  const formRef = (0, _react.useRef)(null);
  //const [issueStartDate, setIssueStartDate] = useState(new Date())

  const defaultHandleSubmit = e => {
    e.preventDefault();
    if (formRef.current !== null) {
      if (formRef.current.reportValidity()) {
        handleSubmit(new FormData(formRef.current));
        setHasValidationErrors(false);
        setTimeout(() => {
          (0, _events.publish)("scripps:action:completed");
          setSubmitBtnDisabled(true);
        }, 500);
      } else {
        setHasValidationErrors(true);
        setTimeout(() => {
          (0, _events.publish)("scripps:action:completed");
        }, 500);
      }
    }
  };
  const handleCategoryChanged = e => {
    const catSelector = document.querySelector('select[name="category"]');
    setCurrentCategory(catSelector === null || catSelector === void 0 ? void 0 : catSelector.children[catSelector.selectedIndex].value);
  };
  (0, _react.useEffect)(() => {
    const category = formSettings.categories.find(cat => Number.parseInt(cat.value, 10) === Number.parseInt(currentCategory, 10));
    if (category) setSubcategories(category.subcategories);
  }, [currentCategory]);
  return /*#__PURE__*/_react.default.createElement("audience-relations-form", null, /*#__PURE__*/_react.default.createElement("form", {
    className: _FormModule.default['form'],
    id: "audience-relations-form",
    ref: formRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    name: "category",
    label: "Category",
    width: 50,
    required: true,
    options: categories,
    onChange: handleCategoryChanged
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    name: "subcategory",
    label: "Sub-Category",
    width: 50,
    required: true,
    options: subcategories
  })), Number.parseInt(currentCategory, 10) === 2 && /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
    name: "issueStartDate",
    width: 50,
    dateFormat: "MMM do, yyyy",
    label: "Issue Start Date",
    maxDate: new Date(),
    helpText: "(optional)"
    //onChange={date => setIssueStartDate(date)}
  }), /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
    name: "issueEndDate",
    width: 50,
    dateFormat: "MMM do, yyyy",
    label: "Issue End Date",
    maxDate: new Date(),
    helpText: "(optional)"
    //minDate={issueStartDate}
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    name: "firstName",
    label: "First Name",
    width: 50,
    required: true
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    name: "lastName",
    label: "Last Name",
    width: 50,
    required: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    type: "email",
    name: "email",
    label: "Email",
    width: 50,
    required: true
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    type: "tel",
    name: "phoneNumber",
    label: "Phone Number",
    width: 50,
    helpText: "(optional - enter numbers only)"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    type: "text",
    name: "city",
    label: "City",
    width: 50,
    required: true
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    name: "state",
    label: "State",
    width: 15,
    required: true,
    options: usStates
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    type: "text",
    name: "zipcode",
    label: "Zip Code",
    width: 35,
    required: true,
    minlength: "5"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    name: "provider",
    label: "TV Provider",
    width: 50,
    required: true,
    options: formSettings.providers
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_TextArea.default, {
    name: "comments",
    label: "Comments",
    helpText: "(optional)",
    width: 100,
    rows: 10
  })), serverErrors.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _helpers.classes)([_FormModule.default['form__errors-list'], 'form__errors-list'])
  }, serverErrors.map((err, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _helpers.classes)([_FormModule.default['errors-list__item'], 'errors-list__item']),
      key: "server-error-".concat(index)
    }, err.message);
  }))), hasValidationErrors && /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__validation-errors']
  }, "Please correct errors above before submitting.")), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form__row']
  }, /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    label: "Submit",
    varient: "action",
    onClick: defaultHandleSubmit,
    disabled: submitBtnDisabled
  }))));
}
var _default = exports.default = AudienceRelationsForm;